let entity = "RETRANSFER"
export const GET_ALL = `GET_ALL_${entity}`
export const GET_ALL_SUCCESS = `GET_ALL_${entity}_SUCCESS`
export const GET_ALL_FAIL = `GET_ALL_${entity}_FAIL`

export const RETRANSFER = `RETRANSFER_${entity}`
export const RETRANSFER_SUCCESS = `RETRANSFER_${entity}_SUCCESS`
export const RETRANSFER_FAIL = `RETRANSFER_${entity}_FAIL`
